import React, { Dispatch, SetStateAction } from 'react';
import { Modal, TouchableOpacity, View } from 'react-native';
import { WindowInformation } from '../../../services/window-information';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';

interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: Dispatch<SetStateAction<boolean>>;
    onClose: () => void;
    videoUrl: string;
}

export default function WatchVideoModal({ onClose, videoUrl, isModalVisible, setModalVisible }: ModalProps) {
    const { styles, theme } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    return (
        <Modal visible={isModalVisible} animationType='fade' onRequestClose={() => {
            setModalVisible(false);
            onClose();
        }} transparent={true}>
            <View style={styles.container}>
                <View style={[styles.formContainer, windowInfo.isMobile ? { width: '95%' } : {}]}>
                    <View style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <TouchableOpacity onPress={onClose}>
                            <FontAwesomeIcon icon={faX} fontSize={16} color={theme.colors.iconColor} />
                        </TouchableOpacity>
                    </View>
                    <video style={styles.videoPlayer(windowInfo.isMobile)} autoPlay controls>
                        <source src={videoUrl} type='video/mp4' />
                    </video>
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1
    },
    formContainer: {
        minWidth: 300,
        minHeight: 150,
        backgroundColor: theme.colors.card.background,
        borderRadius: 4,
        padding: 20,
        rowGap: 25
    },
    videoPlayer: (isMobile: boolean) => ({
        width: isMobile ? '100%' : 640,
        height: isMobile ? 'auto' : 360
    })
}));
